































import Vue, { PropType } from 'vue';
import { Carousel, Slide } from 'vue-carousel';
import AnnotationModel from '@/dex-shared/models/AnnotationModel';
import AnnotationCard from '@/components/correction/AnnotationCard.vue';

export default Vue.extend({
  components: {
    Carousel,
    Slide,
    AnnotationCard,
  },
  props: {
    annotations: {
      type: Array as PropType<AnnotationModel[]>,
      required: true,
    },
  },
});
